import { Box, Grid } from "@mui/material"
import React, { useEffect, useRef } from "react"
import { showNewOfficeSection } from "Pages/Admin/Users/@signals"
import { AppFormSection } from "@components"
import OfficeNameField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeName"
import OfficeTypeField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeType"
import OfficeCodeField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeCode"
import OfficeTimeZoneField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeTZ"
import OfficeCountryField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/OfficeCountry"
import SubmitNewOffice from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice/SubmitOffice"


export default function UserNewOfficeSubSection() {
	const sectionRef = useRef(null)

	useEffect(() => {
		if (showNewOfficeSection.value) {
			sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
		}
	}, [showNewOfficeSection.value])

	if (!showNewOfficeSection.value) return null

	// a sub-card of the Sites & Offices section, as the drawer's other sections
	return <Box ref={sectionRef} sx={{ mb: 2 }}>
		<AppFormSection icon="arrow-right-to-city" title="New Office">
			<Grid container spacing={2}>
				<Grid item xs={8}>
					<OfficeNameField/>
				</Grid>
				<Grid item xs={5}>
					<OfficeTypeField/>
				</Grid>
				<Grid item xs={3.5}>
					<OfficeCodeField/>
				</Grid>
				<Grid item xs={4}>
					<OfficeTimeZoneField/>
				</Grid>
				<Grid item xs={4.5}>
					<OfficeCountryField/>
				</Grid>
				<Grid item xs={4}>
					<SubmitNewOffice/>
				</Grid>
			</Grid>
		</AppFormSection>
	</Box>
}